import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 28a4 4 0 1 1 0-8 4 4 0 0 1 0 8m8-4a4 4 0 1 0 8 0 4 4 0 0 0-8 0m6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m22 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8m2-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Menu-Horizontal-Outlined_svg__a",
      width: 32,
      height: 8,
      x: 8,
      y: 20,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12 28a4 4 0 1 1 0-8 4 4 0 0 1 0 8m8-4a4 4 0 1 0 8 0 4 4 0 0 0-8 0m6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m22 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8m2-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Menu-Horizontal-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgMenuHorizontalOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MenuHorizontalOutlined_default = SvgMenuHorizontalOutlined;

export { MenuHorizontalOutlined_default as default };
